import { AxiosError } from 'axios';

import { useAppQuery } from 'data/query-client';
import { APIErrorResponse } from 'data/query-client/useAppQuery';
import restClient from 'data/restClient';
import { useAuthToken } from 'hooks/useAuthToken';

export interface AuraEmployeeResponse {
  // Success response, there is more data: email_address, job_description, is_manager, and much more
  first_name?: string;
  last_name?: string;
}

export interface AuraEmployeeSearchResponse {
  topics: {
    score: number;
    code: number;
    fcode: number | null;
    name: string;
    photo: string | null;
    seoname: string;
  }[];
}

type Mode = 'id' | 'name';

const getUserData = (authToken: string, djUserId: string) =>
  restClient.get<AuraEmployeeResponse>(`aura/employee/${djUserId}`, {
    headers: { Authorization: authToken }
  });

const searchEmployee = (authToken: string, name: string, currentProperty: string | null) =>
  restClient.get<AuraEmployeeSearchResponse[]>('aura/search', {
    params: { name, property: currentProperty ?? 'wsj' },
    headers: { Authorization: authToken }
  });

export const useAuraQuery = (
  djUserIdOrName: string,
  options?: { enabled?: boolean; mode?: Mode; currentProperty: string | null }
) => {
  const authToken = useAuthToken();
  const mode: Mode = options?.mode ?? 'id';

  return useAppQuery<AuraEmployeeResponse | AuraEmployeeSearchResponse[], AxiosError<APIErrorResponse>>(
    ['aura', mode, djUserIdOrName],
    async () => {
      if (mode === 'id') {
        const one = await getUserData(authToken, djUserIdOrName);
        return one;
      }
      const many = await searchEmployee(authToken, djUserIdOrName, options?.currentProperty ?? null);
      return many;
    },
    {
      enabled: options?.enabled ?? Boolean(djUserIdOrName)
    }
  );
};
